import { useTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { MasteryLevelService } from "../../services/MasteryLevelService";
import { MasteryLevelContext } from "../../utils/Context";
import { sort } from "../../utils/utils";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import MasteryLevels from "./MasteryLevels/MasteryLevels";
import RatingScales from "./RatingScales/RatingScales";
import UnmappedRatingScales from "./RatingScales/UnmappedRatingScales";

const MasteryLevelsAndRatingScales = () => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const { setMasteryLevels: setAppMasteryLevels, setRatingScales } =
    useContext(MasteryLevelContext);
  const [loading, setLoading] = useState(true);

  const [masteryLevels, setMasteryLevels] = useState([]);
  const [updateMasteryLevels, setUpdateMasteryLevels] = useState(true);

  const [mappedRatingScales, setMappedRatingScales] = useState([]);
  const [unmappedRatingScales, setUnmappedRatingScales] = useState([]);
  const [updateMappings, setUpdateMappings] = useState(false);

  useEffect(() => {
    if (updateMasteryLevels) {
      setUpdateMasteryLevels(false);
      setLoading(true);
      MasteryLevelService.getMasteryLevels()
        .then((levels) => {
          setAppMasteryLevels(levels);
          setMasteryLevels(levels);
          setUpdateMappings(true);
        })
        .catch(() =>
          showNotification(
            t("notifications.general.fetchError", {
              obj: t("masteryLevels.masteryLevelsHeader"),
            }),
            ERROR
          )
        );
    }
  }, [updateMasteryLevels, setAppMasteryLevels, showNotification]);

  useEffect(() => {
    if (updateMappings) {
      setUpdateMappings(false);
      setLoading(true);
      MasteryLevelService.getRatingToMasteryLevelMaps()
        .then((maps) => {
          setRatingScales(maps);
          maps.forEach((map) => {
            map.levels.sort((a, b) => a.points - b.points);
          });
          maps = sort(maps, (map) => map.title);
          setMappedRatingScales(
            maps.filter(
              (map) =>
                (!map.is_canvas_default || map.is_mapped) &&
                !map.is_system_generated
            )
          );
          setUnmappedRatingScales(
            maps.filter((map) => map.is_canvas_default && !map.is_mapped)
          );
          setLoading(false);
        })
        .catch(() =>
          showNotification(
            t("notifications.general.fetchError", {
              obj: t("masteryLevels.assessmentScales"),
            }),
            ERROR
          )
        );
    }
  }, [updateMappings, masteryLevels, setRatingScales, showNotification]);

  return (
    <>
      <MasteryLevels
        masteryLevels={masteryLevels}
        loading={loading}
        setUpdateMasteryLevels={setUpdateMasteryLevels}
      />
      <UnmappedRatingScales
        unmappedRatingScales={unmappedRatingScales}
        loading={loading}
        setUpdateMappings={setUpdateMappings}
      />
      <RatingScales
        loading={loading}
        mappedRatingScales={mappedRatingScales}
        setUpdateMappings={setUpdateMappings}
      />
    </>
  );
};

export default MasteryLevelsAndRatingScales;
